// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","532":"styles","883":"component---src-pages-404-js"}[chunkId] + "-" + {"230":"98a4d88b53da769bcf83","532":"1fc74aa866835d8781c3","883":"c566ce61f35b8b0305c9"}[chunkId] + ".js";
};